import StoreModel from '../StoreModel';
import { Action, ActionCreator, Dispatch } from 'redux';
import { AddRaceDTO, Planning, Race, RaceState } from '../../api/model';
import { NotificationActions } from '../notification/notification-actions';
import { AppDispatch, IStore } from '../index';
import { DriverActions } from '../driver';
import { getApi } from '../../api/ApiProvider';

export enum RaceActionsTypes {
    REQUEST_ADD = '[RACES][REQUEST] save',
    RESULT_ADD = '[RACES][RESPONSE] save',
    ERROR_ADD = '[RACES][ERROR] save',

    RESUME_FETCH = '[RACES][REQUEST] fetch',
    RESUME_RESULT = '[RACES][RESPONSE] fetch',
    RESUME_ERROR = '[RACES][ERROR] fetch',

    BY_STATE_FETCH = '[RACES][REQUEST] byState',
    BY_STATE_RESULT = '[RACES][RESULT] byState',
    BY_STATE_ERROR = '[RACES][ERROR] byState',

    ALL_FETCH = '[RACES][REQUEST] all',
    ALL_RESULT = '[RACES][RESULT] all',
    ALL_ERROR = '[RACES][ERROR] all',


    SINGLE_FETCH = '[RACES][REQUEST] single',
    SINGLE_RESULT = '[RACES][RESPONSE] single',
    SINGLE_ERROR = '[RACES][ERROR] single',

    RACE_GET_FILES_REQUEST = '[RACES][REQUEST] getFiles',
    RACE_GET_FILES_RESPONSE = '[RACES][RESPONSE] getFiles',
    RACE_GET_FILES_ERROR = '[RACES][ERROR] getFiles',


    ALL_PLANNING = '[PLANNING][REQUEST] allPlanning',
    ALL_PLANNING_RESULT = '[PLANNING][RESULT] allPlanning',
    ALL_PLANNING_ERROR = '[PLANNING][ERROR] allPlanning',

    DELETE_PLANNING = '[PLANNING][REQUEST] deletePlanning',
    DELETE_PLANNING_RESULT = '[PLANNING][RESULT] deletePlanning',
    DELETE_PLANNING_ERROR = '[PLANNING][ERROR] deletePlanning',

}


export interface AddRaceParams extends Action<RaceActionsTypes> {
    payload: Race
}

export class RaceActions {

    public fetchResume(): ActionCreator<void> {
        return async (d: Dispatch) => {

            d({ type: RaceActionsTypes.RESUME_FETCH });

            try {
                const data = await getApi().race().countByState();
                d({ type: RaceActionsTypes.RESUME_RESULT, payload: data });

            } catch (err) {
                d({ type: RaceActionsTypes.RESUME_ERROR, payload: err });
            }

        }
    }
    public fetchAll() {
        return async (d: Dispatch) => {

            d({ type: RaceActionsTypes.ALL_FETCH });

            try {
                const data = await getApi().race().all(1, 5);
                d({ type: RaceActionsTypes.ALL_RESULT, payload: data.content });

            } catch (err) {
                d({ type: RaceActionsTypes.ALL_ERROR, payload: err });
            }

        }
    }

    public fetchAllWithFilters(
        pageNum?: number, 
        pageSize?: number, 
        search?: string, 
        from?: string, 
        to?: string, 
        type?: string, 
        driverId?: number, 
        selectedState?: string, 
        branchId?: number, 
        branchDestinyId?: number, 
        generalSearch?: string
    ) {
        return async (d: Dispatch) => {
            d({ type: RaceActionsTypes.ALL_FETCH });

            try {
                const data = await getApi().race().all(
                    pageNum, 
                    pageSize, 
                    search, 
                    from, 
                    to, 
                    type, 
                    driverId, 
                    selectedState, 
                    undefined, 
                    undefined, 
                    branchId, 
                    branchDestinyId, 
                    generalSearch
                );
                d({ type: RaceActionsTypes.ALL_RESULT, payload: data });

            } catch (err) {
                d({ type: RaceActionsTypes.ALL_ERROR, payload: err });
            }
        }
    }
    public fetchAllPlaninng() {
        return async (d: Dispatch) => {

            d({ type: RaceActionsTypes.ALL_PLANNING });

            try {
                const data = await getApi().race().allPlaning(0,5);
                d({ type: RaceActionsTypes.ALL_PLANNING_RESULT, payload: data.content });
            } catch (err) {
                d({ type: RaceActionsTypes.ALL_PLANNING_ERROR, payload: err });
            }

        }
    }

    public fetchAllPlanningPaginated(pageNum: number = 0, pageSize: number = 10) {
        return async (d: Dispatch) => {

            d({ type: RaceActionsTypes.ALL_PLANNING });

            try {
                const data = await getApi().race().allPlaning(pageNum, pageSize);
                d({ type: RaceActionsTypes.ALL_PLANNING_RESULT, payload: data.content });
            } catch (err) {
                d({ type: RaceActionsTypes.ALL_PLANNING_ERROR, payload: err });
            }

        }
    }

    public deletePlanning(id: number, pageNum: number = 0, pageSize: number = 10): ActionCreator<void> {
        return async (d: AppDispatch) => {
            d({ type: RaceActionsTypes.DELETE_PLANNING });
            const notif = new NotificationActions();
            try {
                await getApi().race().deletePlanning(id);
                d({ type: RaceActionsTypes.DELETE_PLANNING_RESULT, payload: id });
                d(notif.addSuccess('Planificación', 'Eliminada correctamente'));
                // Refrescar la lista de planificaciones
                d(this.fetchAllPlanningPaginated(pageNum, pageSize));
            } catch (err) { 
                d({ type: RaceActionsTypes.DELETE_PLANNING_ERROR, payload: err });
                d(notif.addError('Planificación', 'Error al eliminar la planificación'));
            }
        }
    }

    fetchWithDriverInfo(id: string, force: boolean): any {
        return async (d: AppDispatch, store: () => IStore) => {

            const isLoaded = StoreModel.isLoaded(store().race.byId[id]);
            if (!force && isLoaded) {
                return;
            }

            if (!isLoaded) {
                d({ type: RaceActionsTypes.SINGLE_FETCH, payload: { id } });
            }
            try {
                const data = await getApi().race().byId(id);
                d({ type: RaceActionsTypes.SINGLE_RESULT, payload: { id, data } })
                if (data.driver) {
                    d(new DriverActions().fetchLocationById(data.driver.id))
                }
            } catch (err) {
                console.log('err', err);
                d({ type: RaceActionsTypes.SINGLE_ERROR, payload: { id, err } })
            }
        }
    }

    public add(race: AddRaceDTO, history: any): ActionCreator<void> {
        return (dispatch: AppDispatch) => {

            dispatch({ type: RaceActionsTypes.REQUEST_ADD });
            const notif = new NotificationActions();

            getApi().race().add(race).then(ok => {

                const action: AddRaceParams = {
                    type: RaceActionsTypes.RESULT_ADD,
                    payload: ok
                };

                dispatch(notif.addSuccess('Reparto', 'Agregado correctamente'));
                dispatch(action);
                history.push('/');
            }, err => {
                const action: AddRaceParams = {
                    type: RaceActionsTypes.ERROR_ADD,
                    payload: err
                };
                dispatch(action);
            });


        };
    }
    public addPlanificationMultiDay(race: Planning, history: any): ActionCreator<void> {
        return (dispatch: AppDispatch) => {

            dispatch({ type: RaceActionsTypes.REQUEST_ADD });
            const notif = new NotificationActions();

            getApi().race().addPlanificationMultiDay(race).then(ok => {

                const action: AddRaceParams = {
                    type: RaceActionsTypes.RESULT_ADD,
                    payload: ok
                };

                dispatch(notif.addSuccess('Planificación', 'Agregado correctamente'));
                dispatch(action);
                history.push('/');
            }, err => {
                const action: AddRaceParams = {
                    type: RaceActionsTypes.ERROR_ADD,
                    payload: err
                };
                dispatch(action);
            });


        };
    }
    public update(race: AddRaceDTO, history: any): ActionCreator<void> {
        return async (dispatch: AppDispatch) => {

            dispatch({ type: RaceActionsTypes.REQUEST_ADD });
            const notif = new NotificationActions();

            try {
                const ok = await getApi().race().update(race);

                const action: AddRaceParams = {
                    type: RaceActionsTypes.RESULT_ADD,
                    payload: ok
                };

                dispatch(notif.addSuccess('Reparto', 'Actualizado correctamente'));
                dispatch(action);
                history.push('/');
            } catch (err) {
                const action: AddRaceParams = {
                    type: RaceActionsTypes.ERROR_ADD,
                    payload: err
                };
                dispatch(action);
            }


        };
    }
    public updateState(race: AddRaceDTO, history: any, onSuccess?: () => void): ActionCreator<void> {
        return async (dispatch: AppDispatch) => {

            dispatch({ type: RaceActionsTypes.REQUEST_ADD });
            const notif = new NotificationActions();

            try {
                const ok = await getApi().race().updateState(race);

                const action: AddRaceParams = {
                    type: RaceActionsTypes.RESULT_ADD,
                    payload: ok
                };

                dispatch(action);
                // dispatch(this.fetchAll()); // Removido: fetchAll trae datos con parámetros fijos
                dispatch(notif.addSuccess('Reparto', 'Actualizado correctamente'));

                // Llamar al callback de éxito si existe
                if (onSuccess) {
                    onSuccess();
                }
            } catch (err) {
                const action: AddRaceParams = {
                    type: RaceActionsTypes.ERROR_ADD,
                    payload: err
                };
                dispatch(action);
            }


        };
    }

    fetchByState(state: RaceState) {

        return (dispatch: Dispatch) => {

            dispatch({ type: RaceActionsTypes.BY_STATE_FETCH, state });
            getApi().race().listByState(state).then(data => {
                dispatch({ type: RaceActionsTypes.BY_STATE_RESULT, payload: data, state });
            }, err => {
                dispatch({ type: RaceActionsTypes.BY_STATE_ERROR, payload: err, state });
            });
        };

    }

    getFiles(raceId: number, id: number) {
        return async (dispatch: AppDispatch) => {
            dispatch({ type: RaceActionsTypes.RACE_GET_FILES_REQUEST });
            getApi().race().getFiles(raceId, id)
                .then(data => {
                    dispatch({ type: RaceActionsTypes.RACE_GET_FILES_RESPONSE, payload: data })
                })
                .catch(err => {
                    dispatch({ type: RaceActionsTypes.RACE_GET_FILES_ERROR, payload: err })
                })
        }
    }

    getScheduleById(id: number) {
        return async (dispatch: Dispatch) => {
            dispatch({ type: RaceActionsTypes.SINGLE_FETCH, payload: { id } });
            try {
                const data = await getApi().race().getScheduleById(id);
                dispatch({ type: RaceActionsTypes.SINGLE_RESULT, payload: { id, data } });
            } catch (err) {
                dispatch({ type: RaceActionsTypes.SINGLE_ERROR, payload: { id, err } });
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/store/race/race-actions.ts